export function parseThinkingProcessLine(line = '') {
  const rawLine = String(line || '').trim();
  const match = rawLine.match(/^\[(pending|skipped|running|completed|partial|degraded|failed|waiting_user|blocked|cancelled|unavailable)\]\s*(.+)$/i);
  return {
    status: match?.[1]?.toLowerCase() || '',
    text: match?.[2] || rawLine,
  };
}

const resolveLegacyProcessSummary = (lines) => {
  const counters = lines.reduce((acc, line) => {
    const status = parseThinkingProcessLine(line).status || 'unknown';
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});
  const total = lines.length;
  const completed = counters.completed ?? 0;
  const summaries = [
    [!total, ''],
    [Boolean(counters.failed), `✕${counters.failed} / ${total}`],
    [Boolean(counters.blocked), `阻塞 · ✓${completed} / ${total}`],
    [Boolean(counters.waiting_user), `等待 · ✓${completed} / ${total}`],
    [Boolean(counters.cancelled), `取消 · ✓${completed} / ${total}`],
    [[counters.partial, counters.degraded].some(Boolean), `部分完成 · ✓${completed} / ${total}`],
    [Boolean(counters.running), `↻${counters.running} · ✓${completed} / ${total}`],
  ];
  return summaries.find(([matches]) => matches)?.[1] ?? `✓${counters.completed ?? total} / ${total}`;
};

const resolveCanonicalProcessSummary = (progress) => {
  const { blocked, completed, failed, running, total } = progress;
  if (![completed, total].every(Number.isFinite)) return '';
  return [
    Number.isFinite(running) && running > 0 ? `进行中 ${running}` : '',
    Number.isFinite(blocked) && blocked > 0 ? `阻塞 ${blocked}` : '',
    Number.isFinite(failed) && failed > 0 ? `失败 ${failed}` : '',
    `✓${completed} / ${total}`,
  ].filter(Boolean).join(' · ');
};

export function resolveProcessSummary(lines = [], progress = null) {
  return progress === null
    ? resolveLegacyProcessSummary(lines)
    : resolveCanonicalProcessSummary(progress);
}
